import type { Notification, NotificationConfigContext } from "../types";
import type { UpdatesInboxMode } from "../utils/timeWindow";
import {
  NotificationCaughtUpEmpty,
  type NotificationCaughtUpMarkAll,
} from "./NotificationCaughtUpEmpty";
import { NotificationObjectMosaic } from "./NotificationObjectMosaic";
import { NotificationSearchEmpty } from "./NotificationSearchEmpty";

export function NotificationNotableView({
  notifications,
  context,
  hasNextPage,
  isFetchingNextPage,
  isLoading,
  onFetchNextPage,
  onBack,
  searchValue,
  onSearchChange,
  markAllAck = null,
  inboxMode = "unread",
  onSeeEarlier,
}: {
  notifications: Notification[];
  context: NotificationConfigContext;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  isLoading?: boolean;
  onFetchNextPage?: () => void;
  onBack: () => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
  markAllAck?: NotificationCaughtUpMarkAll | null;
  inboxMode?: UpdatesInboxMode;
  onSeeEarlier?: () => void;
}) {
  const hasSearch = searchValue.trim().length > 0 && !markAllAck;
  const list = markAllAck ? [] : notifications;
  const loading = markAllAck ? false : !!isLoading;

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <NotificationObjectMosaic
        notifications={list}
        context={context}
        hasNextPage={markAllAck ? false : hasNextPage}
        isFetchingNextPage={markAllAck ? false : !!isFetchingNextPage}
        isLoading={loading}
        onFetchNextPage={onFetchNextPage ?? (() => {})}
        empty={
          hasSearch ? (
            <NotificationSearchEmpty
              caption="Try a different search to find Notable updates."
              onClearSearch={() => onSearchChange("")}
            />
          ) : (
            <NotificationCaughtUpEmpty
              eyebrow="Notable"
              caption="Nothing left that needs your attention right now. Go back when you're ready."
              markAllAck={markAllAck}
              onBack={onBack}
              inboxMode={inboxMode}
              onSeeEarlier={onSeeEarlier}
              classes={{ bg: "bg-violet-500", text: "text-white", ring: "ring-violet-500/20" }}
            />
          )
        }
      />
    </div>
  );
}
